"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVirtualized = require("react-virtualized");

var _excluded = ["Cell", "cellWidth", "cellHeight", "onRowsRendered", "list", "width", "fitHeight"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Grid = function Grid(_ref) {
  var Cell = _ref.Cell,
      cellWidth = _ref.cellWidth,
      cellHeight = _ref.cellHeight,
      onRowsRendered = _ref.onRowsRendered,
      list = _ref.list,
      width = _ref.width,
      fitHeight = _ref.fitHeight,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  (0, _react.useEffect)(function () {
    var columnCount = Math.max(Math.floor(width / cellWidth), 1);
    var columnWidth = Math.floor(width / columnCount);
    var rowCount = Math.ceil(list.length / columnCount);
    var rowHeight = fitHeight ? cellHeight : Math.round(cellHeight * columnWidth / cellWidth);
    setState({
      columnCount: columnCount,
      columnWidth: columnWidth,
      rowCount: rowCount,
      rowHeight: rowHeight
    });
  }, [width, list]);

  var onSectionRendered = function onSectionRendered(_ref2) {
    var columnStartIndex = _ref2.columnStartIndex,
        columnStopIndex = _ref2.columnStopIndex,
        rowStartIndex = _ref2.rowStartIndex,
        rowStopIndex = _ref2.rowStopIndex;
    var columnCount = state.columnCount;
    var startIndex = rowStartIndex * columnCount + columnStartIndex;
    var stopIndex = rowStopIndex * columnCount + columnStopIndex;
    onRowsRendered({
      startIndex: startIndex,
      stopIndex: stopIndex
    });
  };

  var cellRenderer = function cellRenderer(_ref3) {
    var style = _ref3.style,
        columnIndex = _ref3.columnIndex,
        rowIndex = _ref3.rowIndex;
    var columnCount = state.columnCount;
    var index = rowIndex * columnCount + columnIndex;
    var data = list[index];

    if (data) {
      return /*#__PURE__*/_react.default.createElement(Cell, _extends({
        style: style,
        data: data
      }, props, {
        key: data.id
      }));
    }

    return null;
  };

  if (!state.rowCount) return null;
  return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Grid, _extends({}, state, {
    onSectionRendered: onSectionRendered,
    cellRenderer: cellRenderer,
    width: width
  }, props));
};

Grid.propTypes = {
  Cell: _propTypes.default.func.isRequired,
  cellWidth: _propTypes.default.number.isRequired,
  cellHeight: _propTypes.default.number.isRequired,
  onRowsRendered: _propTypes.default.func.isRequired,
  list: _propTypes.default.array,
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired,
  fitHeight: _propTypes.default.bool // in some cases we don't want to calculate rowHeight

};
Grid.defaultProps = {
  list: [],
  width: 0
};
var _default = Grid;
exports.default = _default;